/**
 * @name ID
 * @constant
 * @string
 * @description ID used to identify this modal
 */
export const ID = 'MANAGE_EVIDENCE';

/**
 * @name MAX_SUMMARY_LENGTH
 * @constant
 * @number
 * @description Maximum length a summary can be
 */
export const MAX_SUMMARY_LENGTH = 200;

/**
 * @name VALID_DOMAINS
 * @constant
 * @number
 * @description List of valid domains that can be submitted
 */
export const VALID_DOMAINS = [ 'archive.ph', 'web.archive.org' ];